module.exports = __webpack_public_path__ + "img/7.1e68ace9.png";